import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { API } from '@/utils/api';

export const PROGRESS = {
  prevu: { label: 'Prévu', color: '#FACC15', text: '#0E1116' },
  arrive: { label: 'Arrivé', color: '#3B82F6', text: '#fff' },
  en_cours: { label: 'En cours', color: '#F97316', text: '#fff' },
  pret: { label: 'Prêt', color: '#22C55E', text: '#0E1116' },
  rendu: { label: 'Rendu', color: '#6B7280', text: '#fff' },
};

const Pill = ({ p, big, ...rest }) => (
  <span {...rest} style={{ background: PROGRESS[p].color, color: PROGRESS[p].text, fontWeight: 800, borderRadius: 999, whiteSpace: 'nowrap',
    padding: big ? '0.35em 0.9em' : '0.6mm 2.4mm', fontSize: big ? undefined : '2.8mm', letterSpacing: '0.03em', textTransform: 'uppercase', display: 'inline-block' }}>
    {PROGRESS[p].label}
  </span>
);

export const ProgressPill = ({ item, big = false, onChanged }) => {
  const p = PROGRESS[item.progress] ? item.progress : 'prevu';
  if (!onChanged) return <Pill p={p} big={big} data-testid={`progress-${item.id}`} />;
  const set = async (np) => {
    try { await axios.put(`${API}/agenda/appointments/${item.id}/progress`, { progress: np }); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Statut non modifié'); }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild><button type="button" className="outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-white rounded-full" data-testid={`progress-btn-${item.id}`}><Pill p={p} big={big} data-testid={`progress-${item.id}`} /></button></DropdownMenuTrigger>
      <DropdownMenuContent onCloseAutoFocus={(e) => e.preventDefault()}>
        {Object.keys(PROGRESS).map(k => (
          <DropdownMenuItem key={k} onClick={() => set(k)} data-testid={`progress-set-${k}`}>
            <span className="w-3 h-3 rounded-full mr-2" style={{ background: PROGRESS[k].color }} />{PROGRESS[k].label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
